<template>
  <div id="newsItem" @click="goDetail(data.id)">
    <div class="news-box">
      <p class="title color333">{{ data.title }}</p>
      <p class="from color999">
        <span>{{ moment(data.publishdate).format("YYYY-MM-DD") }}</span>
        <span>{{ data.orgname }}</span>
      </p>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
export default {
  name: "NewsItem",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods:{
    moment,
    goDetail(id){
      if(id){
        this.$router.push('/serviceNews/detail/'+id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.news-box{
  padding: 15px;
  border: 1px solid #F0F0F0;
  border-radius: 5px;
  margin-bottom: 15px;
  .title{
    height: 48px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 5px;
    @extend .font16;
  }
  .from{
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @extend .font13;
    span:first-child{
      padding-right: 5px;
      margin-right: 5px;
      border-right:1px solid #666;
    }
  }
}
</style>
